module.exports = __webpack_public_path__ + "img/82.b2446be2.jpg";